import { connect } from 'react-redux';
import Overlay from './Overlay';
import { getFaveButtonStateWithDefaults } from '../../../../CollectionPanel/redux/selectors';
import { getCurrentUser } from '../../../../publicSession/selectors';
var mapStateToProps = function (state, _a) {
    var _b = _a.deviation, deviationId = _b.deviationId, isFavourited = _b.isFavourited, author = _b.author;
    var currentUser = getCurrentUser(state);
    return {
        isFaved: getFaveButtonStateWithDefaults(state, deviationId, {
            isFavourite: isFavourited,
        }).isFavourite,
        isOwner: !!author && !!currentUser && author.userId === currentUser.userId,
    };
};
export default connect(mapStateToProps)(Overlay);
//# sourceMappingURL=Overlay.container.js.map